export default __webpack_public_path__ + "static/Plots0022-c4975276f82a33f94fffa80ce2a23a58.jpg";